import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

function SubeDegistir() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleSubeChange = () => {
    setShowConfirmDialog(true);
  };

  const handleConfirmSubeChange = () => {
    setShowConfirmDialog(false);
    navigate('/subesecimi');
  };

  const handleCancelSubeChange = () => {
    setShowConfirmDialog(false);
    setError('');
  };

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: "'Roboto', sans-serif"
      }}>
        <p style={{ 
          fontSize: '16px', 
          color: '#dc2626', 
          fontWeight: 'bold',
          padding: '10px 20px',
          backgroundColor: '#ffffff',
          borderRadius: '6px',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)'
        }}>
          {error}
        </p>
      </div>
    );
  }

  return (
    <>
      <Button
        onClick={handleSubeChange}
        style={{
          fontSize: '20px',
          fontFamily: "'Roboto', sans-serif",
          backgroundColor: '#15803d',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: 'bold',
          width: '400px',
          height: '50px',
          lineHeight: '50px',
          padding: '0',
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: '20px'
        }}
      >
        ŞUBE DEĞİŞTİR
      </Button>
      <Dialog open={showConfirmDialog} onClose={handleCancelSubeChange}>
        <DialogTitle style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 'bold' }}>
          Şube Değiştirme Onayı
        </DialogTitle>
        <DialogContent>
          <p style={{ fontSize: '16px', fontFamily: "'Roboto', sans-serif", color: '#1f2937' }}>
            Şubeden çıkış yapmak istiyorsunuz. Şube seçim ekranına yönlendirileceksiniz. Devam edelim mi?
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelSubeChange}
            style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 'bold',
              color: '#dc2626',
              fontSize: '14px'
            }}
          >
            Hayır
          </Button>
          <Button
            onClick={handleConfirmSubeChange}
            style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 'bold',
              backgroundColor: '#15803d',
              color: '#fff',
              fontSize: '14px'
            }}
          >
            Evet
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SubeDegistir;